const roles = [
  "Software Engineers",
  "Data & AI Talent",
  "Product Leaders",
  "Business Analysts",
  "Operations Talent",
];

const HireRoleRailSection = () => {
  return (
    <nav
      className="bg-primary flex items-center gap-2.5 px-4 py-4 overflow-x-auto no-scrollbar"
      aria-label="Popular talent categories"
    >
      <div className="container mx-auto flex items-center gap-2.5">
        <strong className="text-secondary font-poppins text-base font-extrabold flex-shrink-0 mr-2">
          Who are you hiring?
        </strong>
        {roles.map((role) => (
          <a
            key={role}
            href="https://app.utiva.co/signup?goal=employer"
            target="_blank"
            rel="noreferrer noopener"
            className="text-white bg-white/10 border border-white/25 rounded-full flex-shrink-0 flex items-center gap-3 font-poppins font-extrabold text-sm px-4 py-3 hover:border-secondary hover:bg-secondary/10 transition-all"
          >
            {role} <span className="text-secondary">↗</span>
          </a>
        ))}
      </div>
    </nav>
  );
};

export default HireRoleRailSection;
